import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import classnames from 'classnames';
import styles from './List.css';
const List = ({ children, className }) => {
    const classNames = useMemo(() => classnames(styles.container, className), [className]);
    return (_jsx("div", Object.assign({ className: classNames }, { children: children }), void 0));
};
export default memo(List);
